<template>
  <div id="wrapper">
    <SectionHeader :text="$t('media.gallery')" />
    <transition tag="div">
      <Loading v-if="!data" />
      <div
        class="gallery-wrapper"
        v-if="data"
        v-masonry
        transition-duration="0.3s"
        item-selector=".item"
      >
        <div v-masonry-tile class="item" v-for="item in data" :key="item.id">
          <img :src="item.thumbnail" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SectionHeader from "../SectionHeader";
import Loading from "../Loading";

export default {
  name: "Gallery",
  components: { Loading, SectionHeader },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http.get("gallery/").then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
.item {
  width: calc(25% - 30px);
  margin: 0 15px 40px;
}

@media (max-width: 991px) {
  .item {
    width: calc(33.33% - 30px);
  }
}

@media (max-width: 767px) {
  .item {
    width: calc(50% - 30px);
  }
}

@media (max-width: 479px) {
  .item {
    width: calc(100% - 30px);
  }
}
</style>
